import { Alarm, DataVersion } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useSharedAlarm(
  sharedToken: string,
  partitionKey?: string,
  dataVersion?: DataVersion
) {
  const url = `/shared/v2/alarm?sharedToken=${sharedToken}${
    partitionKey ? `&partitionKey=${partitionKey}` : ''
  }`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<Alarm>(request, {
    queryKey: ['alarms', 'shared', sharedToken, partitionKey, dataVersion],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    noAuth: true,
  });
}

export default useSharedAlarm;
